module.exports = __webpack_public_path__ + "ceb6e0dd19ab9316481e0af6c90aff5f.png";